// src/components/HazardGuard.js
import React from 'react';
import {Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

const HazardGuard = ({ children }) => {
  const hazard = useSelector(state => state?.getHazard);
  if (!hazard?.active) {
    return <Redirect to="/"/>;
  }
  return <>{children}</>;
};

HazardGuard.propTypes = {
  children: PropTypes.node
};

export default HazardGuard;
